// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-container {
    height: 100vh;
    display: flex;
    flex-direction: row;
}

.about-container-left {
    width: 50%;
    display: flex;
    text-align: center;
}

.about-container-left-holder {
    margin: auto;
    text-align: left;
    padding: 0 50px;
}

.about-container-left-holder h1 {
    color: var(--text-color-2);
    font-size: 60px;
    margin-bottom: 20px;
}

.about-container-left-holder p {
    color: var(--text-color-2);
    font-size: 18px;
}

.about-container-left-holder p strong {
    color: var(--text-color-3);
}

.about-container-right {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.about-container-right-holder {
    margin: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

#canvasWheel {
    width: 100%;
    aspect-ratio: 1;
}

@media screen and (max-width: 1800px){
    #canvasWheel {
        width: 90%;
    }
}

@media screen and (max-width: 1400px){
    #canvasWheel {
        width: 500px;
        height: 500px;
    }
}

@media screen and (max-width: 1300px){
    #canvasWheel {
        width: 750px;
        height: 750px;
    }

    .about-container {
        flex-direction: column;
        justify-content: space-around;
    }

    .about-container-left {
        width: 100%;
    }

    .about-container-right {
        width: 100%;
    }
}

@media screen and (max-width: 700px){
    #canvasWheel {
        width: 400px;
        height: 400px;
    }
    .about-container-left h1 {
        font-size:40px;
    }

    .about-container-left p {
        font-size: 15px;
    }
}

@media screen and (max-width: 450px) {
    #canvasWheel {
        width: 360px;
        height: 360px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Mainbody/About/About.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,6BAA6B;IACjC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;IACA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;AACJ","sourcesContent":[".about-container {\r\n    height: 100vh;\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.about-container-left {\r\n    width: 50%;\r\n    display: flex;\r\n    text-align: center;\r\n}\r\n\r\n.about-container-left-holder {\r\n    margin: auto;\r\n    text-align: left;\r\n    padding: 0 50px;\r\n}\r\n\r\n.about-container-left-holder h1 {\r\n    color: var(--text-color-2);\r\n    font-size: 60px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.about-container-left-holder p {\r\n    color: var(--text-color-2);\r\n    font-size: 18px;\r\n}\r\n\r\n.about-container-left-holder p strong {\r\n    color: var(--text-color-3);\r\n}\r\n\r\n.about-container-right {\r\n    width: 50%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.about-container-right-holder {\r\n    margin: auto;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n#canvasWheel {\r\n    width: 100%;\r\n    aspect-ratio: 1;\r\n}\r\n\r\n@media screen and (max-width: 1800px){\r\n    #canvasWheel {\r\n        width: 90%;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 1400px){\r\n    #canvasWheel {\r\n        width: 500px;\r\n        height: 500px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 1300px){\r\n    #canvasWheel {\r\n        width: 750px;\r\n        height: 750px;\r\n    }\r\n\r\n    .about-container {\r\n        flex-direction: column;\r\n        justify-content: space-around;\r\n    }\r\n\r\n    .about-container-left {\r\n        width: 100%;\r\n    }\r\n\r\n    .about-container-right {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 700px){\r\n    #canvasWheel {\r\n        width: 400px;\r\n        height: 400px;\r\n    }\r\n    .about-container-left h1 {\r\n        font-size:40px;\r\n    }\r\n\r\n    .about-container-left p {\r\n        font-size: 15px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 450px) {\r\n    #canvasWheel {\r\n        width: 360px;\r\n        height: 360px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
